import { request as __request } from "../core/request";
import { VariableRecurringPaymentConsentResponse } from "../models/VRP/VariableRecurringPaymentConsentResponse";

export class StageRoutingService {
  public static async StageRouting({
    code,
    id_token,
    state,
  }: {
    code: string;
    id_token: string;
    state: string;
  }): Promise<VariableRecurringPaymentConsentResponse> {
    const result = await __request({
      method: "POST",
      path: "/stage-routing",
      query: {
        code: code,
        id_token: id_token,
        state:state
      }
    });
    return result.body;
  }
}
